import Quill, { Parchment } from "quill";

////////////////////////////////////////////////////////////////////////////////

const BlockEmbed = Quill.import("blots/block/embed") as typeof Parchment.EmbedBlot;

export default class PerformaLinkBlot extends BlockEmbed {

    static blotName = 'performaLink';
    static tagName = 'span';
    static className = 'ql-performa-link';

    static create(data: any) {
        if (data.id && data.value) {
            const node: any = super.create();

            const a = document.createElement("a");
            a.setAttribute("data-id", data.id);
            a.setAttribute("data-ot", data.ot);
            // eslint-disable-next-line
            a.setAttribute("href", "javascript:void()");
            a.setAttribute("class", PerformaLinkBlot.className);
            //a.setAttribute("contenteditable", "false");

            a.innerHTML = data.value;

            //node.appendChild(icon);
            node.appendChild(a);

            return node;
        }
        return data;
    }

    static value(domNode: any) {
        return domNode;
    }
}
